'use strict'

export const scroll = (() => {
  const init = () => {
    const buttons = document.querySelectorAll('button[data-block-id]')

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        console.log('clicked', button);
        
        const id = button.dataset.blockId

        if (!id) return

        const section = document.querySelector('section[data-block-id="' + id + '"], div[data-block-id="' + id + '"]')

        if (!section) return

        const rootStyles = getComputedStyle(document.documentElement)
        const headerHeight = rootStyles.getPropertyValue('--header-height')
        const headerFixedHeight = rootStyles.getPropertyValue('--header-fixed-height')
        const offset = parseInt(headerHeight) ? 32 : parseInt(headerFixedHeight) + 20

        window.scrollTo({
          behavior: 'smooth',
          top: section.getBoundingClientRect().top + window.scrollY - offset,
        })
      })
    })
  }

  return {
    init
  }
})()